export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 501,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/ry4z38r"
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 599,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/xppo09x"
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 764,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/xlqozjw"
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 936,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/xq6k1lr"
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 118,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/ry1p63r"
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 1268,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/rdgy24r"
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 1496,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/x8qq55x"
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 1659,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/w0490lx"
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 1836,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/r728l7w"
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 764,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/xlqozjw"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 1268,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/rdgy24r"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 1836,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/r728l7w"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
